module.exports = __webpack_public_path__ + "static/media/security_approved.08727675.png";